import styled from 'styled-components/macro';

// import assets
import headerBannerGrey from '../../../assets/banner/header-banner-grey.jpg';

const BranchListContainer = styled.div`
  background-image: url(${headerBannerGrey});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 2.5rem 25px;

  min-height: 100vh;
`;

export default BranchListContainer;
